<div class="header">
  <a mat-button [routerLink]="'/home'" class="navigation-link">
    <img class="header-icon" src="../../assets/header-icon.png"/>
  </a>

</div>
